export const LaborWageRouting = [
  {
    path: "/report-center/download/labor-wage/list",
    name: "material-labor-wage-list",
    meta: { title: "劳务费汇总表" },
    component: () =>
      import(
        /* webpackChunkName: "labor-wage" */ "@/views/report-center/labor-wage/list/index.vue"
      ),
  },
];
